import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { GET_COMMUNITY_CONTRACT } from "./apiRoutes";
import axiosAuth from "@/services/axiosAuth";

interface UseGetCommunityContractProps {
  id: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">
}

const getCommunityContract = async (id: string) =>
  await axiosAuth.get(`${GET_COMMUNITY_CONTRACT}/${id}`);

const useGetCommunityContract = ({id, queryParams}: UseGetCommunityContractProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["community-contract", id],
    queryFn: () => getCommunityContract(id),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!id && (queryParams?.enabled ?? true),
  });
};

export default useGetCommunityContract;
